<template>
  <cumulus-info-dialog
    v-model="dialogInfo"
    icon="$list"
    :title="$t('operations_list')"
    :loading="loading"
    :max-width="800"
    color="stat"
    activator-icon
    @open="showDialog"
    @escape="closeDialog"
  >
    <template v-slot:info>
      <v-skeleton-loader
        v-if="!stat"
        type="table"
      />
      <v-container v-else>
        <v-data-table
          :headers="stat_headers"
          :items="stat"
          :item-class="rowClasses"
          item-key="year"
          dense
          class="elevation-1"
        >
          <template v-slot:item.operation_date="{item}">
            {{ item.operation_date | dateTimeFormat }}
          </template>
          <template v-slot:item.counter_takeoff="{item}">
            {{ item.counter_takeoff }} -> {{ item.total.takeoff }}
          </template>
          <template v-slot:item.counter_flight="{item}">
            {{ item.counter_flight | minToTimeFormat }} -> {{ item.total.flight | minToTimeFormat }}
          </template>
          <template v-slot:item.counter_engine="{item}">
            {{ item.counter_engine }} -> {{ item.total.engine }}
          </template>
          <template #item.actions="{item}">
            <flight-informations
              :flight="item"
            />
          </template>
        </v-data-table>
      </v-container>
    </template>
  </cumulus-info-dialog>
</template>

<script>

  import { call, get } from 'vuex-pathify'
  import CumulusInfoDialog from '@/components/InfoDialog'
  import FlightInformations from '@/layouts/default/infos/FlightInfo'

  export default {
    name: 'ComponentOperations',
    components: {
      FlightInformations,
      CumulusInfoDialog,
    },
    props: {
      componentId: {
        type: Number,
        default: -1,
      },
    },
    data () {
      return {
        stat: null,
        dialogInfo: false,
        loading: false,
      }
    },
    computed: {
      profile: get('auth/profile'),
      stat_headers () {
        return [
          {
            text: this.$t('fields.operation_date'),
            value: 'operation_date',
          },
          {
            text: this.$t('fields.counter_takeoff'),
            value: 'counter_takeoff',
            width: 140,
          },
          {
            text: this.$t('fields.counter_flight'),
            value: 'counter_flight',
            width: 140,
          },
          {
            text: this.$t('fields.counter_engine'),
            value: 'counter_engine',
          },
          {
            value: 'actions',
            sortable: false,
            align: 'right',
          },
        ]
      },
    },
    watch: {
      dialogInfo (val) {
        // this.showDialogFlightInfo()
        val || this.closeDialog()
      },
    },
    mounted () {
    },
    methods: {
      getOperations: call('component/operations'),
      async showDialog () {
        this.loading = true
        await this.getOperations({ component_id: this.componentId }).then(response => {
          this.stat = response
          this.dialogInfo = true
          this.loading = false
        }).catch(e => {
          this.loading = false
          console.log(e)
        })
      },
      closeDialog () {
        this.stat = null
        this.dialogInfo = false
      },
      rowClasses (item) {
        if (item.status === 'D') {
          return 'red lighten-5'
        }
      },
    },
  }
</script>

<style lang="sass">
.v-dialog
  .v-card
    display: flex !important
    flex-direction: column

  .v-card__text
    flex-grow: 1
    overflow: auto
    // max-height: calc(100vh - 500px)
</style>
